import React from 'react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

interface PostalAddressInputProps {
  value?: string | null;
  onChange: (value: string) => void;
  disabled: boolean;
}

export default function PostalAddressInput({ value, onChange, disabled }: PostalAddressInputProps) {
  const { t } = useTranslation();

  return (
    <TextField
      label={t('formInputs.postalAddressInputLabel')}
      variant='outlined'
      fullWidth
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
  );
}
